import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
    selector: '[onlyNumbers]',
    standalone: false
})
export class OnlyNumbersDirective {
    @HostBinding('attr.autocomplete') public autocomplete;

    constructor() {
        this.autocomplete = 'off';
    }

    @HostListener('keypress', ['$event']) public disableKeys(e) {
        const keyCode = e.keyCode;
        return (keyCode == 8 || (keyCode >= 48 && keyCode <= 57));
    }
}
